/**
 * Replace placeholders in Region Geo Modal heading/body from Contentful (plain text).
 * Tokens are case-insensitive and allow optional spaces inside braces.
 *
 * Supported:
 * - {{detectedRegion}}
 * - {{currentRegion}}
 *
 * @param {string|null|undefined} template - Raw string from CMS
 * @param {{ detectedRegion?: string, currentRegion?: string }} [values]
 * @returns {string}
 */
export function replaceRegionModalTokens(
  template,
  {detectedRegion = '', currentRegion = ''} = {}
) {
  if (template == null || typeof template !== 'string') {
    return '';
  }

  return template
    .replace(/\{\{\s*detectedRegion\s*\}\}/gi, detectedRegion)
    .replace(/\{\{\s*currentRegion\s*\}\}/gi, currentRegion);
}
